import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import EventPage from "../../containers/Event";

const Components = ({ match }) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/view`} />
    <Route path={`${match.url}/view`} component={EventPage} />
  </Switch>
);

export default Components;
